import { PlaceholderReplacer } from "../ComposableResolver.js";

/**
 * replaces [random] placeholders with timestamp
 */
export const RandomReplacer: PlaceholderReplacer = ["random", (k: string) => {
    return new Date().getTime() + "";
}];





